import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {BackendApi, localhost} from '../../../config/backend-api';
import {QuestionnaireEvaluationComponent} from '../questionnaire-evaluation/questionnaire-evaluation.component';
import {Patient} from '../../../model/user/Patient';
import {Store} from '@ngrx/store';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Q_CLINICAL_SCCAI} from '../../../model/questionnaires/questionnaire-clinical-sccai';
import {HttpClient} from '@angular/common/http';
import {AppState} from '../../../store/app.states';
import {MatSnackBar} from '@angular/material/snack-bar';
import {doctorDispatching, EvaluationDTO} from '../utils';

export interface ClinicalSCCAIDialogData {
  id: string;
  date: string;
  results: string[];
  finalScore: number;
  patientChosen: Patient;
  role: string;
  read: boolean;
  warning: boolean;
  evaluation: boolean;
}


@Component({
  selector: 'app-clinical-sccai-result-dialog',
  templateUrl: './clinical-sccai-result-dialog.component.html',
  styleUrls: ['./clinical-sccai-result-dialog.component.css']
})
export class ClinicalSccaiResultDialogComponent implements OnInit, OnDestroy {

  questions = Q_CLINICAL_SCCAI;
  displayedColumns = ['position', 'question', 'value'];
  diagnosis: string;

  read: boolean;
  warning: boolean;
  evaluation: boolean;

  constructor(public dialogRef: MatDialogRef<ClinicalSccaiResultDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: ClinicalSCCAIDialogData,
              private httpClient: HttpClient,
              public dialog: MatDialog,
              private store: Store<AppState>,
              private snackBar: MatSnackBar) {
  }

  ngOnInit(): void {
    console.log(this.data.role);
    if (this.data.finalScore < 5) {
      this.diagnosis = 'Remissione';
    } else {
      this.diagnosis = 'Recidiva';
    }

    this.read = this.data.read;
    this.warning = this.data.warning;
    this.evaluation = this.data.evaluation;

    if (this.data.role === 'DOTTORE') {
      setTimeout(() => {
        this.read = true;
      }, 500);
    }
  }

  evaluate() {
    if (this.data.role === 'DOTTORE') {
      this.dialog.open(QuestionnaireEvaluationComponent, {
        width: '500px',
        height: '290px',
        data: ['Ok', 'Segnala']
      }).afterClosed().subscribe(res => {
        if (res === undefined) {
          console.log(res);
        } else {

          const id = this.data.id.split('-');
          const date = id[0];
          const type = id[1] + '-' + id[2];
          const doctorID = id[3];
          const patientSSN = id[4];

          let evaluation;

          if (res === 'Segnala') {
            // tslint:disable-next-line:max-line-length
            evaluation = new EvaluationDTO(date, false);
            this.evaluation = false;
            this.warning = true;

          } else if (res === 'Ok') {
            evaluation = new EvaluationDTO(date, true);
            this.evaluation = true;
            this.warning = false;
          }

          console.log('qua', type);

          // tslint:disable-next-line:max-line-length
          return this.httpClient.post(localhost +
            BackendApi.EVALUATE_QUESTIONNAIRE + type + '/' + doctorID + '/' + patientSSN,
            evaluation, {observe: 'response', responseType: 'text'})
            .subscribe(response => {
              if (response.status === 200) {
                if (this.data.role === 'DOTTORE') {
                  doctorDispatching(this.store, type, patientSSN);
                } else if (this.data.role === 'PAZIENTE') {
                  /*patientDispatching(this.patientService)*/
                }
                if (!evaluation.evaluation) {
                  this.snackBar.open('Segnalazione effettuata correttamente.', 'Chiudi', {
                    duration: 2000
                  });
                } else {
                  this.snackBar.open('Valutazione effettuata correttamente.', 'Chiudi', {
                    duration: 2000
                  });
                }
              }
            });
        }
      });
    }
  }

  warn() {
    if (this.data.role === 'PAZIENTE') {
      const splitted = this.data.id.split('-');
      console.log(splitted);
      const date = splitted[0];
      const type = splitted[1] + '-' + splitted[2];
      const doctorID = splitted[3];
      const patientSSN = splitted[4];
      // tslint:disable-next-line:max-line-length
      return this.httpClient.post(localhost + BackendApi.WARN_DOCTOR + type + '/' + doctorID + '/' + patientSSN, date, {observe: 'response', responseType: 'text'})
        .subscribe(res => {
          if (res.status === 200) {
            this.evaluation = false;
            this.warning = true;
            this.snackBar.open('Segnalazione effettuata correttamente.', 'Chiudi', {
              duration: 2000
            });
            // tslint:disable-next-line:max-line-length
          }
        });
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    const id = this.data.id.split('-');
    const type = id[1] + '-' + id[2];
    const patientSSN = id[4];
    if (this.data.role === 'DOTTORE') {
      doctorDispatching(this.store, type, patientSSN);
    } else if (this.data.role === 'PAZIENTE') {
      /*patientDispatching(this.patientService)*/
    }
  }


}
